import React from 'react'
import clsx from 'clsx'
import { Country, State } from 'country-state-city'

import InputText from '../InputText'
import SelectInput from '../SelectInput'
import Icon from '../Icon/Icon'

import './step2.scss'

export const Step2 = ({
  otherClasses,
  country,
  setCountry,
  region,
  setRegion,
  handleChange,
  errorMessage,
  choices,
  addChoiceHandler,
  removeChoiceHandler,
  onChoiceChange,
  state,
}) => {
  const step2Classes = clsx(
    otherClasses,
    'px-6 pt-6 pb-5 lg:pt-[40px] lg:px-[40px] flex flex-col gap-6 lg:gap-[40px] '
  )
  const allCountries = [...Country.getAllCountries()]

  const date = new Date(new Date().getFullYear() - 18, 11, 31)

  const alphaNumaricZipCodes = ['Canada']

  return (
    <div className={step2Classes} data-testid="step2">
      <div className="lg:pb-[40px] pb-6 border-b-[1px] border-b-gray-100 ">
        <div className="w-full flex flex-col gap-6">
          <label
            htmlFor="Project Name"
            className="font-work-sans text-[16px] lg:text-[20px] font-semibold text-primary_heading_color  leading-[27px]"
          >
            Purchaser Info
          </label>
          <div className="flex flex-col gap-6 text">
            <div className="grid grid-cols-1 lg:grid-cols-2 w-full  gap-y-2 lg:gap-y-6 lg:gap-x-6">
              <div className="w-full flex flex-col gap-2">
                <InputText
                  labelClasses="font-work-sans text-[14px] lg:text-[16px] font-semibold  text-primary_heading_color  leading-[24px]"
                  required={true}
                  warning={errorMessage?.firstname}
                  label="Name"
                  onChange={handleChange}
                  name={'firstname'}
                  value={state.firstname || ''}
                  placeholder="First Name"
                  type="text"
                />
              </div>
              <div className="w-full flex flex-col gap-2 justify-end">
                <InputText
                  labelClasses="hidden font-work-sans text-[14px] lg:text-[16px] font-semibold text-primary_heading_color leading-[24px] "
                  required={true}
                  warning={errorMessage?.lastname}
                  label=" "
                  iconClasses="top-[50%]"
                  onChange={handleChange}
                  name={'lastname'}
                  value={state?.lastname || ''}
                  placeholder={'Last Name'}
                  type="text"
                />
              </div>
              {/* <div className="w-full flex flex-col gap-2">
                <label
                  htmlFor="SIN #"
                  className="font-work-sans text-[14px] lg:text-[16px] font-semibold  text-primary_heading_color  leading-[24px]"
                >
                  SIN #{' '}
                  <span className="font-work-sans text-[14px] lg:text-[16px] font-semibold  text-gray-500  leading-[24px]">
                    (optional)
                  </span>
                </label>
                <InputText
                  required={true}
                  name={'sin'}
                  value={state?.sin || ''}
                  onChange={handleChange}
                  placeholder="SIN #"
                  type="text"
                />
              </div>
              <div className="w-full flex flex-col gap-2">
                <label
                  className="font-work-sans text-[14px] lg:text-[16px] font-semibold  text-primary_heading_color  leading-[24px]"
                  htmlFor="date_of_birth"
                >
                  Date of Birth <span className="text-red-500">*</span>
                </label>
                <InputText
                  required={true}
                  warning={errorMessage?.date_of_birth}
                  otherClasses="relative"
                  name={'date_of_birth'}
                  onChange={handleChange}
                  value={state.date_of_birth || ''}
                  placeholder={'DD/MM/YY'}
                  type="date"
                  min="1950-01-01"
                  max={`${date.getFullYear()}-${
                    date.getMonth() + 1
                  }-${date.getDate()}`}
                />
              </div> */}
            </div>
            <div className="w-full flex flex-col gap-10 justify-end">
              <InputText
                required={true}
                label="Street Address"
                name={'address_1'}
                // iconClasses="top-[50%]"
                warning={errorMessage?.address_1}
                value={state?.address_1 || ''}
                onChange={handleChange}
                // placeholder="Address Line 1"
                type="text"
                labelClasses="!text-base"
              />
              <InputText
                required={false}
                label="Address Line 2"
                name={'address_2'}
                iconClasses="top-[50%]"
                warning={errorMessage?.address_2}
                value={state?.address_2 || ''}
                onChange={handleChange}
                // placeholder={'Address Line 2'}
                type="text"
                labelClasses="!text-base"
              />
              <div className="grid grid-cols-1 lg:grid-cols-3 w-full  gap-y-2 lg:gap-y-6 lg:gap-x-6">
                <div className="w-full flex flex-col gap-2">
                  <label
                    htmlFor="Country"
                    className="font-work-sans text-[14px] lg:text-[16px] font-semibold  text-primary_heading_color  leading-[24px]"
                  >
                    Country <span className="text-red-500">*</span>
                  </label>
                  <SelectInput
                    warning={errorMessage?.country}
                    allOptions={[
                      ...Country.getAllCountries().map(({ name }) => name),
                    ]}
                    defaultValue="Select Country"
                    selectedOption={country}
                    setSelectedoption={setCountry}
                  />
                </div>
                <div className="w-full flex flex-col gap-2">
                  <label
                    htmlFor="City"
                    className="font-work-sans text-[14px] lg:text-[16px] font-semibold  text-primary_heading_color  leading-[24px]"
                  >
                    City <span className="text-red-500">*</span>
                  </label>
                  <InputText
                    iconClasses="top-[50%]"
                    warning={errorMessage?.city}
                    required={true}
                    name={'city'}
                    value={state?.city || ''}
                    onChange={handleChange}
                    placeholder="City"
                    type="text"
                  />
                </div>
                <div className="w-full flex flex-col gap-2">
                  <label
                    htmlFor="SIN #"
                    className="whitespace-nowrap font-work-sans text-[14px] lg:text-[16px] font-semibold  text-primary_heading_color  leading-[24px]"
                  >
                    State / Province / Region{' '}
                    <span className="text-red-500">*</span>
                  </label>
                  <SelectInput
                    warning={errorMessage?.region}
                    allOptions={
                      State.getStatesOfCountry(
                        allCountries.find((node) => node.name === country)
                          ?.isoCode
                      ).map(({ name }) => name).length === 0
                        ? ['Select the Country First']
                        : State.getStatesOfCountry(
                            allCountries.find((node) => node.name === country)
                              ?.isoCode
                          ).map(({ name }) => name)
                    }
                    defaultValue="Select Region"
                    selectedOption={region}
                    setSelectedoption={setRegion}
                  />
                </div>
              </div>
              <InputText
                warning={errorMessage?.zipcode}
                // iconClasses="top-[50%]"
                required={true}
                label="Zip Code"
                name={'zipcode'}
                value={state?.zipcode || ''}
                onChange={handleChange}
                // placeholder="Postal / Zip Code"
                labelClasses="!text-base"
                type={
                  alphaNumaricZipCodes.some((nodes) => nodes === country)
                    ? 'text'
                    : 'number'
                }
              />
              <InputText
                required={true}
                name={'cell_number'}
                labelClasses="!text-base"
                label="Phone"
                // iconClasses="top-[50%]"
                warning={errorMessage?.cell_number}
                value={state?.cell_number || ''}
                onChange={handleChange}
                // placeholder="Enter Your Cell Phone Number"
                type="number"
              />
              <InputText
                required={true}
                warning={errorMessage?.date_of_birth}
                otherClasses="relative"
                labelClasses="!text-base"
                label="Birthdate"
                name={'date_of_birth'}
                onChange={handleChange}
                value={state.date_of_birth || ''}
                placeholder={'DD/MM/YY'}
                type="date"
                min="1950-01-01"
                max={`${date.getFullYear()}-${
                  date.getMonth() + 1
                }-${date.getDate()}`}
              />
              <div className="grid grid-cols-1 lg:grid-cols-2 w-full  gap-y-2 lg:gap-y-6 lg:gap-x-6">
                <div className="w-full flex flex-col gap-2">
                  <InputText
                    required={true}
                    labelClasses="!text-base"
                    label="Enter email"
                    iconClasses=""
                    warning={errorMessage?.email}
                    name={'email'}
                    value={state?.email || ''}
                    onChange={handleChange}
                    placeholder={'Email'}
                    type="email"
                  />
                </div>
                <div className="w-full flex flex-col gap-2 justify-end">
                  <InputText
                    required={true}
                    iconClasses="top-[50%]"
                    warning={errorMessage?.confirmEmail}
                    name={'confirmEmail'}
                    value={state?.confirmEmail || ''}
                    onChange={handleChange}
                    placeholder={'Confirm email'}
                    type="email"
                  />
                </div>
              </div>
              <InputText
                required={true}
                name={'job_title'}
                labelClasses="!text-base"
                label="Occupation - Job Title"
                // iconClasses="top-[50%]"
                warning={errorMessage?.job_title}
                value={state?.job_title || ''}
                onChange={handleChange}
                type="text"
              />
              <InputText
                required={true}
                labelClasses="!text-base"
                label="Occupation - Employer Name"
                warning={errorMessage?.employer}
                name={'employer'}
                value={state?.employer || ''}
                onChange={handleChange}
                type="text"
              />
              <InputText
                required={true}
                labelClasses="!text-base"
                label="SIN"
                name={'sin'}
                warning={errorMessage?.sin}
                value={state?.sin || ''}
                onChange={handleChange}
                // placeholder="SIN #"
                type="text"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="lg:pb-[40px] pb-6 mb-10 ">
        <div className="flex flex-col gap-6 lg:gap-[40px]  ">
          {choices?.length > 0 &&
            choices.map((choice, index) => {
              return (
                <div key={index} className="flex flex-col gap-6">
                  <div className="flex justify-between">
                    <label
                      htmlFor="choice"
                      className="font-work-sans text-[16px] lg:text-[20px] font-semibold text-primary_heading_color  leading-[27px]"
                    >
                      Floor Plan #{index + 1}
                    </label>
                    {index > 0 && (
                      <button
                        onClick={() => removeChoiceHandler(index)}
                        className="border-[1px] rounded-lg border-primary_heading_color"
                      >
                        <Icon icon="minus" iconHeight={24} iconWidth={24} />
                      </button>
                    )}
                  </div>

                  <div className="grid grid-cols-1 lg:grid-cols-2 w-full  gap-y-2 lg:gap-y-0 lg:gap-x-6">
                    <div className="w-full flex flex-col gap-2">
                      <InputText
                        id={index}
                        label="Model Name"
                        labelClasses="!text-base"
                        required={false}
                        name={'modal'}
                        warning={index === errorMessage?.modal}
                        onChange={onChoiceChange}
                        value={choice?.modal || ''}
                        placeholder={'Example: 1A0B'}
                        type="text"
                      />
                    </div>
                    <div className="w-full flex flex-col gap-2">
                      <InputText
                        id={index}
                        labelClasses="!text-base"
                        label="Type"
                        warning={index === errorMessage.type}
                        required={false}
                        name={'type'}
                        onChange={onChoiceChange}
                        value={choice.type || ''}
                        placeholder={'Example: 1 Bed + Den'}
                        type="text"
                      />
                    </div>
                  </div>
                </div>
              )
            })}
        </div>
        <button
          type="button"
          className=" mt-6 lg:mt-[40px] lg:tracking-[0.42px] uppercase font-work-sans text-[12px] tracking-[0.36px] lg:text-[14px] font-semibold leading-[18px] "
          onClick={() => addChoiceHandler()}
        >
          + Add another choice
        </button>
      </div>
      <div className="flex flex-col gap-6 lg:gap-[40px] ">
        <div className="flex flex-col lg:flex-row gap-4 pb-10 lg:gap-[64px] border-b-[1px] border-b-gray-100">
          <div className="flex flex-col gap-4">
            <label
              htmlFor="parking"
              className={clsx(
                errorMessage?.parking
                  ? 'font-work-sans text-[16px] lg:text-[20px] font-semibold text-[#ff4444]  leading-[27px]'
                  : 'font-work-sans text-[16px] lg:text-[20px] font-semibold text-primary_heading_color  leading-[27px]'
              )}
            >
              Parking <span className="text-red-500">*</span>
            </label>
            <div className="flex gap-6">
              <label
                className=" container flex gap-2 font-work-sans text-[12px] lg:text-[14px] font-normal text-primary_heading_color leading-[20px]"
                htmlFor="parking-yes"
              >
                <input
                  onChange={(e) => handleChange(e)}
                  type="radio"
                  required={true}
                  id="parking-yes"
                  name="parking"
                  value="yes"
                  checked={state?.parking === 'yes'}
                  className="radio_button"
                />
                <span className={clsx('checkmark')}></span>
                Yes
              </label>

              <label
                className="container flex gap-2 font-work-sans text-[12px] lg:text-[14px] font-normal text-primary_heading_color leading-[20px]"
                htmlFor="parking-no"
              >
                <input
                  type="radio"
                  onChange={(e) => handleChange(e)}
                  id="parking-no"
                  required={true}
                  checked={state?.parking === 'no'}
                  name="parking"
                  value="no"
                  className="radio_button"
                />
                <span className={clsx('checkmark')}></span>
                No
              </label>
            </div>
          </div>
          <div className="flex flex-col gap-4">
            <label
              htmlFor="locker"
              className={clsx(
                errorMessage?.locker
                  ? 'font-work-sans text-[16px] lg:text-[20px] font-semibold text-[#ff4444]  leading-[27px]'
                  : 'font-work-sans text-[16px] lg:text-[20px] font-semibold text-primary_heading_color  leading-[27px]'
              )}
            >
              Locker <span className="text-red-500">*</span>
            </label>
            <div className="flex gap-6">
              <label
                className="container flex gap-2 font-work-sans text-[12px] lg:text-[14px] font-normal text-primary_heading_color leading-[20px]"
                htmlFor="locker-yes"
              >
                <input
                  type="radio"
                  onChange={(e) => handleChange(e)}
                  id="locker-yes"
                  name="locker"
                  required={true}
                  checked={state?.locker === 'yes'}
                  value="yes"
                  className="radio_button"
                />
                <span className={clsx('checkmark')}></span>
                Yes
              </label>
              <label
                className=" container flex gap-2 font-work-sans text-[12px] lg:text-[14px] font-normal text-primary_heading_color leading-[20px]"
                htmlFor="locker-no"
              >
                <input
                  type="radio"
                  id="locker-no"
                  name="locker"
                  required={true}
                  onChange={(e) => handleChange(e)}
                  checked={state?.locker === 'no'}
                  value="no"
                  className="radio_button"
                />
                <span className={clsx('checkmark')}></span>
                No
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Step2
